import crudHandlers from "./_crud";

export default (state, action) => {
  const {type} = action;
  switch (type) {
    case 'FETCH_TRAILER_GROUPS_ERROR':
      return { ...state, is_fetching: false }
    
    default:

      state = crudHandlers(state, action, 'trailer_group')

      return state
  }
}
